


export const PRODUCT_ENDPOINTS = {
  // Product CRUD
  STATUS: { path: `/products/status`, method: "GET" },
  CREATE_PRODUCT: { path: `/products/create`, method: "POST" },
  GET_PRODUCTS: { path: `/products`, method: "GET" },
  GET_PRODUCT: { path: `/products/:productId`, method: "GET" },
  UPDATE_PRODUCT: { path: `/products/:productId`, method: "PUT" },
  UPLOAD_IMAGES: { path: `/products/:productId/images`, method: "POST" },
  DELETE_PRODUCT: { path: `/products/:productId`, method: "DELETE" },
  UPDATE_STOCK: { path: `/products/:productId/stock`, method: "PATCH" },
  
  // Availability Management
  ADD_AVAILABILITY: { path: `/products/:productId/availability`, method: "POST" },
  GET_AVAILABILITY: { path: `/products/:productId/availability`, method: "GET" },
  REMOVE_AVAILABILITY: { path: `/products/:productId/availability/:availabilityId`, method: "DELETE" },
  ADD_BLACKOUT: { path: `/products/:productId/blackouts`, method: "POST" },
  GET_BLACKOUTS: { path: `/products/:productId/blackouts`, method: "GET" },
  REMOVE_BLACKOUT: { path: `/products/:productId/blackouts/:blackoutId`, method: "DELETE" },
  
  // Booking Management
  CHECK_AVAILABILITY: { path: `/products/:productId/check-availability`, method: "POST" },
  CREATE_BOOKING: { path: `/bookings/create`, method: "POST" },
  GET_BOOKINGS: { path: `/bookings`, method: "GET" },
  GET_MY_BOOKINGS: { path: `/bookings/my`, method: "GET" },
  GET_BOOKING: { path: `/bookings/:bookingId`, method: "GET" },
  UPDATE_BOOKING: { path: `/bookings/:bookingId`, method: "PUT" },
  CANCEL_BOOKING: { path: `/bookings/:bookingId/cancel`, method: "POST" },
  CONFIRM_BOOKING: { path: `/bookings/:bookingId/confirm`, method: "POST" },
  COMPLETE_BOOKING: { path: `/bookings/:bookingId/complete`, method: "POST" },
  
  // Inventory Management
  GET_INVENTORY: { path: `/inventory`, method: "GET" },
  ADJUST_STOCK: { path: `/inventory/:productId/adjust`, method: "POST" },
  GET_INVENTORY_LOG: { path: `/inventory/:productId/logs`, method: "GET" },
  GET_LOW_STOCK: { path: `/inventory/low-stock`, method: "GET" },
  
  // Admin Endpoints
  ADMIN_GET_ALL_PRODUCTS: { path: `/admin/products`, method: "GET" },
  ADMIN_GET_ALL_BOOKINGS: { path: `/admin/bookings`, method: "GET" },
  ADMIN_GET_STATS: { path: `/admin/products/stats`, method: "GET" },
  ADMIN_BULK_UPDATE_STOCK: { path: `/admin/products/bulk-stock`, method: "POST" },
};